<template>
    <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000;max-height: 280px;overflow: hidden;"
        v-model="slide"
        :interval="3000"
        background="#ababab"
        img-width="1024"
        img-height="480"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
    >
        <b-carousel-slide
        img-src="https://picsum.photos/1024/480/?image=10"
        ></b-carousel-slide>
        <b-carousel-slide
        img-src="https://picsum.photos/1024/480/?image=12"
        ></b-carousel-slide>
        <b-carousel-slide
        img-src="https://picsum.photos/1024/480/?image=22"
        ></b-carousel-slide>
    </b-carousel>
  </template>
  
  <script>
//   import HelloWorld from '@/components/HelloWorld.vue'
  import navigation from '@/components/navigation.vue'
import { RouterView } from 'vue-router';
  export default {
    name: 'app-main',
    components: {
    navigation,
    RouterView
},
    props: { 
      msg: String
    },
    data(){
        return {
            slide: 0,
        sliding: null
        }
    },
    methods:{
        onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>
  